import React, { useState, useEffect } from "react";
import { Card, Dropdown, Row, Col } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { FiChevronDown } from "react-icons/fi";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function TopCountries() {
  const countries = [
    {
      name: "Singapore",
      leads: 236,
      flag: "/assets/img/flags/singapore.png",
      color: "#F26522",
    },
    {
      name: "France",
      leads: 589,
      flag: "/assets/img/flags/fr.png",
      color: "#0F4C5C",
    },
    {
      name: "Norway",
      leads: 221,
      flag: "/assets/img/flags/norway.png",
      color: "#2F80ED",
    },
    {
      name: "USA",
      leads: 350,
      flag: "/assets/img/flags/us.png",
      color: "#EB5757",
    },
    {
      name: "UAE",
      leads: 221,
      flag: "/assets/img/flags/ae.png",
      color: "#F2C94C",
    },
  ];

  // 🔥 STATES
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeLabel, setActiveLabel] = useState("");
  const [activeValue, setActiveValue] = useState(0);
  const [activeColor, setActiveColor] = useState("");

  // ✅ DEFAULT = HIGHEST VALUE
  useEffect(() => {
    const maxIndex = countries.findIndex(
      (c) => c.leads === Math.max(...countries.map((x) => x.leads))
    );

    setActiveIndex(maxIndex);
    setActiveLabel(countries[maxIndex].name);
    setActiveValue(countries[maxIndex].leads);
    setActiveColor(countries[maxIndex].color);
  }, []);

  // ✅ CHART DATA
  const data = {
    labels: countries.map((c) => c.name),
    datasets: [
      {
        data: countries.map((c) => c.leads),
        backgroundColor: countries.map((c) => c.color),
        borderColor: "#fff",
        borderWidth: 2,
        hoverOffset: 8,
      },
    ],
  };

  // ✅ OPTIONS (MAIN LOGIC)
  const options = {
    cutout: "70%",
    onHover: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;

        setActiveIndex(index);
        setActiveLabel(countries[index].name);
        setActiveValue(countries[index].leads);
        setActiveColor(countries[index].color);
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: activeColor,
        displayColors: false,
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
    },
  };

  return (
    <Card className="top-country-card p-3 shadow-sm h-100">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-semibold mb-0">Top Countries</h5>

        <Dropdown>
          <Dropdown.Toggle className="bg-white border rounded-3 text-dark border-0 d-flex align-items-center">
            Referrals <FiChevronDown className="ms-1" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>Referrals</Dropdown.Item>
            <Dropdown.Item>Sales Pipline</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      <Row className="align-items-center">
        {/* LEFT SIDE */}
        <Col md={5} xs={12}>
          {countries.map((c, i) => (
            <div
              key={i}
              className="d-flex align-items-center mb-1 country-item"
            >
              {/* DOT */}
              <span
                className="me-2"
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: c.color,
                  display: "inline-block",
                }}
              />

              {/* FLAG */}
              <img
                src={c.flag}
                alt={c.name}
                className="flag-img me-2"
              />

              {/* TEXT */}
              <div>
                <div className="fw-medium">{c.name}</div>
                <small className="text-muted">
                  Leads : {c.leads}
                </small>
              </div>
            </div>
          ))}
        </Col>

        {/* RIGHT SIDE */}
        <Col md={7} xs={12} className="text-center position-relative">
          <div className="chart-wrapper">
            <Doughnut data={data} options={options} />
          </div>

          {/* CENTER TEXT */}
          <div className="chart-center-text">
            <div style={{ color: activeColor }}>
              {activeLabel}
            </div>
            <h4 style={{ color: activeColor }}>
              {activeValue}
            </h4>
          </div>
        </Col>
      </Row>
  <style>
     {
          `
          .top-country-card {
  border-radius: 5px;
  border:"2px solid #e5e7eb"
}

/* Country list */
.country-item {
  padding: 5px 4px;
  border-radius: 6px;
  transition: 0.2s;
}

.country-item:hover {
  background: #f6f6f6;
}

/* Flag */
.flag-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

/* Chart */
.chart-wrapper {
  max-width: 260px;
  margin: 0 auto;
  position: relative;
}

/* Center text */
.chart-center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Mobile */
@media (max-width: 768px) {
  .chart-wrapper {
    max-width: 200px;
  }

  .flag-img {
    width: 30px;
    height: 30px;
  }
}`
     }
  </style>
    </Card>
  );
}